import { Outlet } from "react-router-dom"

const Loginlayout = () => {
    return(
        <div>
            <Outlet />
        </div>
    );
}

export default Loginlayout;